'use strict';

class StatusManager {

  static TABLE_STATUS_UPLOADED = 'UPLOADED';
  static PRE_PROCESSING_IN_PROGRESS = 'PRE PROCESSING IN PROGRESS';
  static PRE_PROCESSING_ERROR = 'PRE PROCESSING IN ERROR';
  static PRE_PROCESSING_FAILED = 'PRE PROCESSING FAILED';
  static PRE_PROCESSING_DONE = 'PRE PROCESSING DONE';
  static ANNOTATION_IN_PROGRESS = 'ANNOTATION IN PROGRESS';
  static ANNOTATION_ERROR = 'ANNOTATION IN ERROR';
  static ANNOTATION_FAILED = 'ANNOTATION FAILED';
  static ANNOTATION_DONE = 'ANNOTATION DONE';

  
  static TABLE_CREATION_STATUS = StatusManager.TABLE_STATUS_UPLOADED;
  
  static ALLOWED_STATUS_LIST_FOR_STARTING_PREPROCESSING_TASK = [
    StatusManager.TABLE_STATUS_UPLOADED,
    StatusManager.PRE_PROCESSING_IN_PROGRESS,
    StatusManager.PRE_PROCESSING_ERROR,
    StatusManager.PRE_PROCESSING_FAILED,
    StatusManager.PRE_PROCESSING_DONE,
    // StatusManager.ANNOTATION_IN_PROGRESS,
    StatusManager.ANNOTATION_ERROR,
    StatusManager.ANNOTATION_FAILED,
    StatusManager.ANNOTATION_DONE
  ];
  static STATUS_LIST_FOR_PREPROCESSING_NOT_STARTED = [
    StatusManager.TABLE_STATUS_UPLOADED
  ];
  static STATUS_LIST_FOR_PREPROCESSING_TASK_NOT_FINISHED = [
    StatusManager.PRE_PROCESSING_IN_PROGRESS
  ];
  static STATUS_LIST_FOR_PREPROCESSING_TASK_DONE_WITH_SUCCESS = [
    // StatusManager.TABLE_STATUS_UPLOADED,
    // StatusManager.PRE_PROCESSING_IN_PROGRESS,
    // StatusManager.PRE_PROCESSING_ERROR,
    // StatusManager.PRE_PROCESSING_FAILED,
    StatusManager.PRE_PROCESSING_DONE,
    StatusManager.ANNOTATION_IN_PROGRESS,
    StatusManager.ANNOTATION_ERROR,
    StatusManager.ANNOTATION_FAILED,
    StatusManager.ANNOTATION_DONE
  ];
  static STATUS_LIST_FOR_PREPROCESSING_TASK_DONE_WITH_FAILURE = [
    StatusManager.PRE_PROCESSING_ERROR,
    StatusManager.PRE_PROCESSING_FAILED
  ];


  static ALLOWED_STATUS_LIST_FOR_STARTING_ANNOTATION_TASK = [
    // StatusManager.TABLE_STATUS_UPLOADED,
    // StatusManager.PRE_PROCESSING_IN_PROGRESS,
    // StatusManager.PRE_PROCESSING_ERROR,
    // StatusManager.PRE_PROCESSING_FAILED,
    StatusManager.PRE_PROCESSING_DONE,
    StatusManager.ANNOTATION_IN_PROGRESS,
    StatusManager.ANNOTATION_ERROR,
    StatusManager.ANNOTATION_FAILED,
    StatusManager.ANNOTATION_DONE
  ];
  static STATUS_LIST_FOR_ANNOTATION_NOT_STARTED = [
    StatusManager.TABLE_STATUS_UPLOADED,
    StatusManager.PRE_PROCESSING_IN_PROGRESS,
    StatusManager.PRE_PROCESSING_ERROR,
    StatusManager.PRE_PROCESSING_FAILED,
    StatusManager.PRE_PROCESSING_DONE,
    // StatusManager.ANNOTATION_IN_PROGRESS,
    // StatusManager.ANNOTATION_ERROR,
    // StatusManager.ANNOTATION_FAILED,
    // StatusManager.ANNOTATION_DONE
  ];
  static STATUS_LIST_FOR_ANNOTATION_TASK_NOT_FINISHED = [
    StatusManager.ANNOTATION_IN_PROGRESS
  ];
  static STATUS_LIST_FOR_ANNOTATION_TASK_DONE_WITH_SUCCESS = [
    StatusManager.ANNOTATION_DONE
  ];
  static STATUS_LIST_FOR_ANNOTATION_TASK_DONE_WITH_FAILURE = [
    StatusManager.ANNOTATION_ERROR,
    StatusManager.ANNOTATION_FAILED
  ];


}

module.exports = StatusManager;